class ShopPayWidget extends HTMLElement {
    connectedCallback() {
        this.form = this.querySelector('form.installment');
        this.input = this.querySelector('[data-variant-input]');
        this.source = this.closest('[data-product-card-selected_variant_id]');

        if (!this.form || !this.input || !this.source) return;

        this.currentId = this.input.value;

        this.observer = new MutationObserver(this.handleMutations.bind(this));

        this.observer.observe(this.source, {
            attributes: true,
            attributeFilter: ['data-product-card-selected_variant_id']
        });
    }

    disconnectedCallback() {
        this.observer?.disconnect();
    }

    handleMutations() {
        cancelAnimationFrame(this.raf);

        this.raf = requestAnimationFrame(() => {
            const id = this.source.getAttribute('data-product-card-selected_variant_id');

            if (!id || id === this.currentId) return;

            this.updateWidget(id);
        });
    }

    updateWidget(variantId) {
        this.currentId = variantId;
        this.input.value = variantId;

        this.form.dispatchEvent(new Event('change', { bubbles: true }));
        document.dispatchEvent(
            new CustomEvent('variant:change', {
                detail: { variant: { id: variantId } }
            })
        );
    }
}

customElements.define('shop-pay-widget', ShopPayWidget);